// extracted by mini-css-extract-plugin
module.exports = {"container":"teachingExperience_container__BRpTL","item":"teachingExperience_item__1A1ER","itemYear":"teachingExperience_itemYear__1I4Wy"};